import { render, staticRenderFns } from "./home_title.vue?vue&type=template&id=5af82944&scoped=true"
import script from "./home_title.vue?vue&type=script&lang=js"
export * from "./home_title.vue?vue&type=script&lang=js"
import style0 from "./home_title.vue?vue&type=style&index=0&id=5af82944&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af82944",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5af82944')) {
      api.createRecord('5af82944', component.options)
    } else {
      api.reload('5af82944', component.options)
    }
    module.hot.accept("./home_title.vue?vue&type=template&id=5af82944&scoped=true", function () {
      api.rerender('5af82944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/home_title.vue"
export default component.exports